import React, { useEffect, useState } from 'react'
import CheckoutProduct from './CheckoutProduct';
import './Payment.css'
import { useStateValue } from './StateProvider'
import { Link, useHistory } from 'react-router-dom';
import { CardElement, useElements, useStripe } from '@stripe/react-stripe-js';
import CurrencyFormat from 'react-currency-format';
import { getCartTotal } from './reducer';
import axios from './axios';
import { db } from './firebase';
function Payment() {
    const [{ cart, user }, dispatch] = useStateValue();
    const stripe = useStripe();
    const history = useHistory();
    const elements = useElements();
    const [succeeded, setSucceeded] = useState(false);
    const [processing, setProcessing] = useState("");
    const [error, setError] = useState(null);
    const [disabled, setDisabled] = useState(true);
    const [clientSecret, setClientSecret] = useState(true);
    const [streetAddress, setStreetAddress] = useState('');
    const [apt, setApt] = useState('');
    const [city, setCity] = useState('');
    const [state, setState] = useState('');
    const [zipCode, setZipCode] = useState('');

    useEffect(() => {
        //generate the special stripe secrect which allows us to charge a customer
        const getClientSecret = async () => {
            try {
                const response = await axios({
                    method: 'post',
                    url: `/payments/create?total=${getCartTotal(cart) * 100}`
                });
                setClientSecret(response.data.clientSecret);
            }
            catch (err) {
                console.warn(err);
                setClientSecret(true);
            }
        }
        getClientSecret();
    }, [cart])
    console.log("Client Secret is >>>> ", clientSecret);
    const handleSubmit = async (event) => {
        event.preventDefault();
        setProcessing(true);


        if (clientSecret !== true) {
            const payload = await stripe.confirmCardPayment(clientSecret, {
                payment_method: {
                    card: elements.getElement(CardElement)
                }
            }).then(({ paymentIntent }) => {
                //paymentIntent = payment confirmation
                console.log(streetAddress)
                db
                    .collection('users')
                    .doc(user?.uid)
                    .collection('orders')
                    .doc(paymentIntent.id)
                    .set({
                        cart: cart,
                        amount: paymentIntent.amount,
                        created: paymentIntent.created,
                        address: {
                            street: streetAddress,
                            apt: apt,
                            city: city,
                            state: state,
                            zip: zipCode
                        }
                    })
                setSucceeded(true);
                setError(null);
                setProcessing(false);
                dispatch({
                    type: 'EMPTY_CART'
                })
                history.replace('/orders')
            })
        }
    }

    const handleChange = e => {
        setDisabled(e.epmty);
        setError(e.error ? e.error.message : "");
    }
    return (
        <div className="payment">
            <div className="payment__container">
                <h1>Checkout (<Link to="/Checkout">{cart?.length} {cart?.length === 1 ? "item" : "items"}</Link>)</h1>
                <div className="payment__section">
                    <div className="payment__title">
                        <h3>1   Shipping address</h3>
                    </div>
                    <div className="payment__address">
                        <p>{user?.email}</p>
                        <form className="payment__addressForm">
                            <div className="payment__addressFirst">
                                <input className="payment__streetAddress" placeholder="Street Address" value={streetAddress} onChange={e => setStreetAddress(e.target.value)}></input>
                                <input className="payment__apt" placeholder="Apt" value={apt} onChange={e => setApt(e.target.value)}></input>
                            </div>
                            <div className="payment__addressSecond">
                                <input className="payment__city" placeholder="City" value={city} onChange={e => setCity(e.target.value)}></input>
                                <input className="payment__state" placeholder="State" value={state} onChange={e => setState(e.target.value)}></input>
                                <input className="payment__zipCode" placeholder="Zip Code" value={zipCode} onChange={e => setZipCode(e.target.value)}></input>
                            </div>
                        </form>

                    </div>
                </div>
                <div className="payment__section">
                    <div className="payment__title">
                        <h3>2   Payment method</h3>
                    </div>
                    <div className="payment__details">
                        {/* Stripe for payment transactions */}
                        <form onSubmit={handleSubmit} >
                            <CardElement onChange={handleChange} />
                            <div className="payment__priceContainer">
                                <CurrencyFormat
                                    renderText={(value) => (
                                        <>
                                            <h3>Order Total: {value}</h3>
                                        </>
                                    )}
                                    decimalScale={2}
                                    value={getCartTotal(cart)}
                                    displayType={"text"}
                                    thousandSeparator={true}
                                    prefix={"$"}
                                />
                                <button className="payment__button" onClick={handleSubmit} disabled={processing || disabled || succeeded}>
                                    <span>{processing ? <p>Processing</p> : "Place you order"}</span>
                                </button>
                            </div>
                            {/* Errors */}
                            {error && <div>{error}</div>}
                        </form>
                    </div>
                </div>
                <div className="payment__section">
                    <div className="payment__title">
                        <h3>3 Review items and shipping</h3>
                    </div>
                    <div className="payment__items">
                        {cart.map(item => (
                            <CheckoutProduct
                                id={item.id}
                                title={item.title}
                                price={item.price}
                                rating={item.rating}
                                image={item.image} />
                        ))}
                    </div>
                </div>
            </div>
        </div>
    )
}

export default Payment
